module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_m_leucistic.b56394fd.png";